export default __webpack_public_path__ + "static/media/include_9_female@3x.04f0213c.jpg";